<div class="Flex--col">
    <Data :data.sync="local.tab" value="startseite" />

    <portal to="AppHeader">

        <SmartButton v-model="local.tab" set="startseite" :unset="local.tab">Startseite</SmartButton>
        <strong>→</strong>
        <div class="InputGroup">
            
            <SmartButton class="Button Input" v-model="local.tab" set="strukturindikatoren" :unset="local.tab">Strukturindikatoren</SmartButton>
            <SmartButton class="Button Input" v-model="local.tab" set="dynamik" :unset="local.tab">Dynamikindikatoren</SmartButton>
            <SmartButton class="Button Input" v-model="local.tab" set="top" :unset="local.tab">TOP-Indikatoren</SmartButton>
            <SmartButton class="Button Input" v-model="local.tab" set="absolut" :unset="local.tab">Absolutwerte</SmartButton>

            <!--
            <SmartButton v-model="local.tab" set="metropolregionen" :unset="local.tab">Metropolregionen</SmartButton>
            -->
        </div>
        <div style="flex:1" />
    </portal>

    <div class="Flex--col">
        <SM3Startseite v-if="local.tab == 'startseite'" />
        <SM3Strukturindikatoren v-if="local.tab == 'strukturindikatoren'" />
        <SM3Dynamik v-if="local.tab == 'dynamik'" />
        <SM3Top v-if="local.tab == 'top'" />
        <SM3Absolut v-if="local.tab == 'absolut'" />
        <SM3Metropolregionen v-if="local.tab == 'metropolregionen'" />
    </div>
</div>
